import Pagination from '../valueobjects/Pagination';
import Area, { AreaInitializer } from './Area';
import ExploreMerchant from './ExploreMerchant';
import ExploreStation, { ExploreStationInitializer } from './ExploreStation';

export default class ExploreCategoryStation {
  public readonly exploreStation: ExploreStation;
  public readonly exploerMerchants: ExploreMerchant[];
  public readonly pagination: Pagination;
  public readonly area: Area;

  constructor(init: ExploreCategoryStationInitializer) {
    this.exploreStation = new ExploreStation(init.exploreStation);
    this.exploerMerchants = init.exploerMerchants.map(
      exploerMerchant => new ExploreMerchant(exploerMerchant),
    );
    this.pagination = new Pagination(init.pagination);
    this.area = new Area(init.area);
  }
}

export interface ExploreCategoryStationInitializer {
  exploreStation: ExploreStationInitializer;
  exploerMerchants: ExploreMerchant[];
  pagination: Pagination;
  area: AreaInitializer;
}
